export const TINYMCE_API_KEY = 'wxh8jkstmo647jvq9c9bss0z3mpef1j282cid1nygaasuz43';
